import instance from 'services/api';

export const updateCachingEvent = (uuid, body) => {
  return instance.patch(`caching/event/update/${uuid}`, body);
};

export const createCachingEvent = (body) => {
  return instance.post(`caching/event/create`, body);
};
